import { SectionHubPage } from "../../components/SectionHubPage/SectionHubPage";
import { operationsHubCards } from "../../navigation/appNavigation";

const OperationsHubPage = () => (
    <SectionHubPage title="Operations" cards={operationsHubCards} />
);

export { OperationsHubPage };
